import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  ReservationBusinessMonthlyRepport,
  ReservationBusinessPropertyMonthlyRepport,
  ReservationBusinessPropertyYearlyRepport,
  ReservationBusinessSourceReport,
  ReservationBusinessYearlyRepport
} from "../../Services/Service";


// 🔹 Business Source Report
export const fetchBusinessSourceReport = createAsyncThunk(
  "businessSourceReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationBusinessSourceReport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);


// 🔹 Monthly Report
export const fetchBusinessMonthlyReport = createAsyncThunk(
  "businessMonthlyReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationBusinessMonthlyRepport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);


export const fetchBusinessPropertyMonthlyReport = createAsyncThunk(
  "businessPropertyMonthlyReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationBusinessPropertyMonthlyRepport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);

export const fetchBusinessYearlyReport = createAsyncThunk(
  "businessYearlyReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationBusinessYearlyRepport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);

export const fetchBusinessPropertyYearlyReport = createAsyncThunk(
  "businesspropertYearlyReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationBusinessPropertyYearlyRepport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);


const businessSourceReportSlice = createSlice({
  name: "businessSourceReport",
  initialState: {
    // 🔹 Source report
    data: [],
    // 🔹 Monthly report (NEW)
    monthlyData: [],
    PropertymonthlyData: [],
    yearlyData: [],
    PropertyYearlyData: [],
    loading: false,
    error: null,


  },

  reducers: {
    clearReport: (state) => {
      state.data = [];
    },
    clearMonthlyReport: (state) => {
      state.monthlyData = [];
    },
    clearPropertyMonthlyReport: (state) => {
      state.PropertymonthlyData = [];
    },
    clearYearlyReport: (state) => {
      state.yearlyData = [];
    },
    clearPropertyYearlyReport: (state) => {
      state.PropertyYearlyData = [];
    },
  },

  extraReducers: (builder) => {
    builder

      // ==============================
      // 🔹 Business Source Report
      // ==============================
      .addCase(fetchBusinessSourceReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessSourceReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBusinessSourceReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      // ==============================
      // 🔹 Monthly Report (NEW)
      // ==============================
      .addCase(fetchBusinessMonthlyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessMonthlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyData = action.payload;
      })
      .addCase(fetchBusinessMonthlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==============================
      // 🔹Property Monthly Report (NEW)
      // ==============================
      .addCase(fetchBusinessPropertyMonthlyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessPropertyMonthlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.PropertymonthlyData = action.payload;
      })
      .addCase(fetchBusinessPropertyMonthlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==============================
      // 🔹Yearly Report (NEW)
      // ==============================
      .addCase(fetchBusinessYearlyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessYearlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.yearlyData = action.payload;
      })
      .addCase(fetchBusinessYearlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ==============================
      // 🔹Property Yearly Report (NEW)
      // ==============================
      .addCase(fetchBusinessPropertyYearlyReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessPropertyYearlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.PropertyYearlyData = action.payload;
      })
      .addCase(fetchBusinessPropertyYearlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export const { clearReport, clearMonthlyReport } = businessSourceReportSlice.actions;
export default businessSourceReportSlice.reducer;